import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService, Role } from './auth.service';

export function roleGuard(min: Role): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    if (auth.hasRole(min)) return true;
    router.navigate(['/dashboard']);
    return false;
  };
}
